import { createFileRoute } from '@tanstack/react-router';

import { AdminPage } from '@/features/admin/AdminPage';

/** `/admin` —— 後台。無權限時頁面自己畫「找不到」。 */
export const Route = createFileRoute('/admin')({
  component: AdminPage,
});
